import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class NoteService {
  addNote(data) {
    return axios.post(API_URL + "note/add-note", data, {
      headers: authHeader(),
    });
  }

  updateNote(data, id) {
    return axios.put(`${API_URL}note/update-note/${id}`, data, {
      headers: authHeader(),
    });
  }

  fetchNotes(noteType, recordId) {
    return axios.get(`${API_URL}note/fetch-notes/${noteType}/${recordId}`, {
      headers: authHeader(),
    });
  }

  deleteNote(id) {
    return axios.delete(`${API_URL}note/delete/${id}`, {
      headers: authHeader(),
    });
  }
}

export default new NoteService();
